module.exports = __webpack_public_path__ + "img/candidate_assessment.5c172d42.png";